var _defs, _path, _g, _polygon, _g2, _path2, _path3, _path4, _path5, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4e211;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-6{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-3{stroke:#000;}.cls-4{fill:#fff;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{stroke:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M697,218.19l99.74-117.73a27.44,27.44,0,0,1,32.74-7l150.79,71.92a27.42,27.42,0,0,1,14.93,30.86L958.2,358a6.62,6.62,0,0,1-9.57,4.35L698.87,228.28A6.61,6.61,0,0,1,697,218.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "393.04 795.42 652.77 297.86 930 439.39 667.8 939.29 393.04 795.42"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M697,218.19l99.74-117.73a27.44,27.44,0,0,1,32.74-7l150.79,71.92a27.42,27.42,0,0,1,14.93,30.86L958.2,358a6.62,6.62,0,0,1-9.57,4.35L698.87,228.28A6.61,6.61,0,0,1,697,218.19Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 813.12,
    y1: 255.88,
    x2: 930,
    y2: 318.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M971.51,176.84c-2.27-2.44-4.61-4.93-7.57-6.46-3.32-1.73-7.63-2.06-10.56.48a5.74,5.74,0,0,0-1.11,7.79c3.58,4.61,13.18,1,14.72,7.55a6.94,6.94,0,0,1-1.78,6.19,28.67,28.67,0,0,0-6.78,13.54c-.51,2.6-.64,5.43,1.1,7.64a4.44,4.44,0,0,0,2.84,1.69c2.81.36,4.43-2,5.11-4.37s.74-4.81,2.28-6.79a4.34,4.34,0,0,1,1.71-1.32c2.72-1.13,4.56,1.07,4.85,3.26v.05a1.72,1.72,0,0,0,3,.94,22.09,22.09,0,0,0,3.75-20.3c-2.83-8.43-9.49-13.86-19.18-16.35"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "393.04 795.42 652.77 297.86 930 439.39 667.8 939.29 393.04 795.42"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.53,
    y1: 363.13,
    x2: 500.82,
    y2: 649.82
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.72,809.49h0a42.66,42.66,0,0,1,56.06-16.81L677.57,922.37l36.72-21.2a10.62,10.62,0,0,1,5.33-1.43h20.69v19.77a10.71,10.71,0,0,1-1.42,5.33l-17.48,30.28L708.9,987.58A42.66,42.66,0,0,1,649.26,1010L379.84,868.59A42.65,42.65,0,0,1,362.72,809.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M675.08,263.78,940.41,396.45a25.91,25.91,0,0,1,10.85,36.13l-1.51,2.62a25.91,25.91,0,0,1-34.26,10.1L651.67,310a25.9,25.9,0,0,1-10.9-35.51h0A25.92,25.92,0,0,1,675.08,263.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M665.62,230.52h0a24,24,0,0,1,31.75-9.28L948.76,350.72a11.78,11.78,0,0,0,13.58-2L986.89,325a11.79,11.79,0,0,1,8.18-3.31h0a11.77,11.77,0,0,1,11.78,11.78v2.46a11.78,11.78,0,0,1-1.68,6.07l-34.53,57.42a11.78,11.78,0,0,1-15.36,4.46L675.64,264.06A24,24,0,0,1,665.62,230.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M940.7,428.69l87.39,131.54a16.86,16.86,0,0,1-1.11,20.14L800.63,850.87l-17.78,1-43.51,57-13.83-9.13,48.85-58.6V824.61l217.55-256a16.85,16.85,0,0,0,1.3-20.09l-74.64-115Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 675.64,
    y1: 264.06,
    x2: 940.41,
    y2: 396.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 407.26,
    y1: 819.04,
    x2: 649.4,
    y2: 939.29
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 834.6,
    y1: 768.13,
    x2: 940.41,
    y2: 646.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects09);
export default __webpack_public_path__ + "static/media/objects-09.78f9df27f823ee96529b525d90fd010a.svg";
export { ForwardRef as ReactComponent };